import { EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { FormEventService, FormService } from "app/services";
import { PageLoaderService } from "app/services/PageLoader";
import { NotificationService } from "app/services/index";
import { ConfirmationService } from "primeng/api";
import { BaseFormComponent } from "./BaseFormComponent";
import { AppInjector } from "./app-injector.service";

export abstract class BaseFormDialogComponent extends BaseFormComponent {
  constructor(
    protected fb: FormBuilder,
    protected formService: FormService,
    protected formEventService: FormEventService,
    protected notificationService: NotificationService | undefined = undefined,
    protected pageLoaderService: PageLoaderService | undefined = undefined,
    protected confirmationService: ConfirmationService | undefined = undefined
  ) {
    super(
      fb,
      formService,
      formEventService,
      notificationService,
      pageLoaderService,
      confirmationService
    );

    const injector = AppInjector.getInjector();
    if (notificationService === undefined) {
      this.notificationService = injector.get(NotificationService);
    }
    if (pageLoaderService === undefined) {
      this.pageLoaderService = injector.get(PageLoaderService);
    }
    if (confirmationService === undefined) {
      this.confirmationService = injector.get(ConfirmationService);
    }
  }

  public isVisible: boolean = false;
  @Output() displayChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  get display(): boolean {
    return this.isVisible;
  }

  set display(val) {
    this.isVisible = val;
    this.displayChange.emit(val);
  }

  hide(): void {
    this.display = false;
  }

  show(): void {
    this.display = true;
  }
}
